import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './UploadImageButton.module.scss';
import cx from 'classnames';

const UploadImageButton = ({
  name,
  register,
  setValue,
  setError,
  clearError,
  getValues,
  watch,
  disabled,
}) => {
  useEffect(() => {
    register({ name });
  });

  const handleImage = ({ target: { files } }) => {
    const promises = [];

    clearError();

    const oldImages = getValues()[name] || [];

    if (files.length + oldImages.length > 5) {
      setError('image', 'max', 'max 5 images');
      return;
    }

    for (var i = 0; i < files.length; i++) {
      const file = files[i];

      switch (file.name.match(/\.[0-9a-z]+$/i)[0].toLowerCase()) {
        case '.gif':
        case '.png':
        case '.jpeg':
        case '.jpg':
          break;
        default:
          setError('image', 'type', `${file.name} is wrong file type`);
          return;
      }

      if (file.size > 10 * 1024 * 1024) {
        setError('image', 'large', `Image ${file.name} is too large`);
        return;
      }

      promises.push(
        new Promise(resolve => {
          const reader = new FileReader();
          reader.onload = _ =>
            resolve({ file, url: reader.result });
          reader.readAsDataURL(file);
        })
      );
    }

    Promise.all(promises).then(images =>
      setValue(name, images.concat(oldImages))
    );
  };

  function handleRemove(i) {
    let list = [...getValues()[name]];
    list.splice(i, 1);
    setValue(name, list);
    clearError();
  }

  return (
    <div className={styles.addImage}>
      {watch(name) && watch(name).length > 0 && (
        <div className={styles.images}>
          {watch(name).map(({ url, file }, i) => (
            <div onClick={() => handleRemove(i)} key={i}>
              <img src={url} alt={file.name} />
            </div>
          ))}
        </div>
      )}
      <label htmlFor="image" className={cx(disabled && styles.disabled)}>
        Add Image
      </label>
      <input
        id="image"
        accept="image/*"
        type="file"
        multiple
        onChange={handleImage}
        disabled={disabled}
      />
    </div>
  );
};

UploadImageButton.propTypes = {
  name: PropTypes.string.isRequired,
  register: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
  setError: PropTypes.func.isRequired,
  clearError: PropTypes.func.isRequired,
  getValues: PropTypes.func.isRequired,
  watch: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
};

UploadImageButton.defaultProps = { value: [], disabled: false };

export default UploadImageButton;
